import {Icon} from '@rocket-ui/components';
import classNames from 'classnames';
import React from 'react';
import {Slide, toast, ToastContent, ToastOptions} from 'react-toastify';
import styles from './Notification.module.css';
import {TOAST_CONTAINER_ID} from './NotificationsContainer';

export const showNotification = (text: ToastContent, {className, bodyClassName, ...props}: ToastOptions = {}): void => {
	toast(text, {
		containerId: TOAST_CONTAINER_ID,
		position: 'bottom-right',
		autoClose: false,
		closeButton: <Icon name="cross-mini" className={styles.close} circular />,
		hideProgressBar: true,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		className: classNames(styles.wrapper, stringOrEmpty(className)),
		bodyClassName: classNames(styles.content, stringOrEmpty(bodyClassName)),
		transition: (props) => {
			return <Slide {...props} position={props.isIn ? 'bottom-center' : 'bottom-right'} />;
		},
		...props,
	});
};

function stringOrEmpty(value: any): string | undefined {
	if (typeof value === 'string') return value;
}

export const closeNotification = (id?: string | number) => toast.dismiss(id);
